import { render, staticRenderFns } from "./fonts.vue?vue&type=template&id=056b1482"
import script from "./fonts.vue?vue&type=script&lang=js"
export * from "./fonts.vue?vue&type=script&lang=js"
import style0 from "./fonts.vue?vue&type=style&index=0&id=056b1482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports